import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import { toViewDate } from '../../../helpers/formatter/dateFormatters'
import { useReports } from '../../Team/Context/ReportsContext'
import { useCohorts } from '../../Team/Hooks/useCohorts'

export const NetworkCohortsSelect = () => {
    const { t } = useTranslation('teamReports')
    const { optionsSelected, setOptionsSelected } = useReports()
    const { networkCohorts } = useCohorts()
    const options = networkCohorts?.map(({ startDate, name }) => {
        return { label: `${toViewDate(startDate)} - ${name}`, value: toViewDate(startDate) }
    })

    const isSingleCohort = options?.length === 1

    return (
        <div className="cohort-header">
            <Select
                onChange={(values) => setOptionsSelected(values)}
                value={isSingleCohort ? options : optionsSelected}
                defaultValue={optionsSelected}
                isMulti
                isSearchable={!isSingleCohort}
                isDisabled={isSingleCohort}
                options={options}
                placeholder={t('All Cohorts')}
                noOptionsMessage={() => t('No options')}
                styles={{ container: (provided) => ({ ...provided, minWidth: '400px' }) }}
            />
        </div>
    )
}
